// src/api/dict.js
import request from "../utils/request";
// 接口前缀：和asset.js保持统一的基础地址+模块路径
const apiPrefix = "/dict";

// 1. 根据字典类型获取字典项
export const getDictItemsByType = (type) => {
  return request.get(`${apiPrefix}/items/${type}`);
};

// 2. 删除字典项
export const deleteDictItem = (id) => {
  return request.delete(`${apiPrefix}/items/${id}`);
};

// 3. 新增字典项
export const createDictItem = (data) => {
  return request.post(`${apiPrefix}/items`, data);
};

// 4. 编辑字典项
export const updateDictItem = (id, data) => {
  return request.put(`${apiPrefix}/items/${id}`, data);
};

// 5. 获取所有字典类型
export const getDictTypes = () => {
  return request.get(`${apiPrefix}/types`);
};

// 6. 删除字典类型
export const deleteDictType = (id) => {
  return request.delete(`${apiPrefix}/types/${id}`);
};

// 7. 新增字典类型
export const createDictType = (data) => {
  return request.post(`${apiPrefix}/types`, data);
};

// 8. 编辑字典类型
export const updateDictType = (id, data) => {
  return request.put(`${apiPrefix}/types/${id}`, data);
};
